import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import DraftUploader from '../../../../FormComponents/DraftUploader'
import { useParams } from 'react-router-dom'
import { toastSuccess, toastError } from '../../../../FormComponents/Toasts'
import { DraftContext } from '../../../../../contexts/DraftContext'
import Action from '../../../../../models/Action'
import DraftUpload from '../../../../../models/DraftUpload'
import { useReadOnly } from '../../../../../contexts/ReadOnlyContext'


export default observer(function ImageWindow() {
  const readOnly = useReadOnly()
  const { id, action_id} = useParams()
  const { actions } = useContext(DraftContext)
  const action = actions.find(action => +action.id === +action_id) || new Action()
  
  return (
    <div className='w-[650px] h-[228px] flex justify-center items-center rounded-lg border-1 border-primary bg-white'>
      {readOnly ? <p className='text-rb-mat-grey'>No uploads</p> : <DraftUploader
        url={`/api/project_manager/campaigns/${id}/actions/${action_id}/draft_uploads`}
        onDocumentUpload={response => {
          response.forEach(draft => {
            action.draft_uploads.push(new DraftUpload(draft))
          })
          const fileCount = response.length
          toastSuccess(`${fileCount} ${fileCount === 1 ? 'upload' : 'uploads'} added!`)
        }}
        onDocumentUploadFailure={(error) => toastError(error)}
      />}
    </div>
  )
})
